import {
  AdvancedMarker,
  InfoWindow,
  Map,
  MapProps,
  Pin,
  RenderingType,
  useAdvancedMarkerRef
} from '@vis.gl/react-google-maps';
import cx from 'classnames';
import { googleMapsMapId } from '~/constants/environment';
import {
  useDealershipAddress,
  useDealershipConfiguration
} from '~/context/dealership/StaticContext';
import EmptyErrorBoundary from '~/utilities/ErrorBoundary/EmptyErrorBoundary';
import styles from './GoogleMap.module.css';

export default function GoogleMap(props: MapProps) {
  const configuration = useDealershipConfiguration();
  const address = useDealershipAddress();
  const [markerRef, marker] = useAdvancedMarkerRef();

  return (
    <EmptyErrorBoundary location="Dealership Google Map">
      <Map
        className={cx('absolute inset-0', styles.map)}
        mapId={googleMapsMapId}
        clickableIcons={false}
        disableDefaultUI
        gestureHandling="none"
        keyboardShortcuts={false}
        renderingType={RenderingType.VECTOR}
        {...props}
      >
        <AdvancedMarker
          ref={markerRef}
          position={address.position}
          title={configuration.fullName}
        >
          <Pin scale={0.8} />
        </AdvancedMarker>
        <InfoWindow
          anchor={marker}
          className="max-w-[200px] text-center text-sm font-medium leading-16 text-red-2 sm:text-left"
          style={{
            textShadow: '0 2px white, 0 -2px white, 2px 0 white, -2px 0 white'
          }}
        >
          {configuration.fullName}
        </InfoWindow>
      </Map>
    </EmptyErrorBoundary>
  );
}
